export default __webpack_public_path__ + "static/media/Q11_1_resized.ad299f97.jpg";